<script lang="ts">
  import { CHATTY_GATEWAY_MODE, ChattyAuthBootstrap } from "@office-agents/chatty";
  import { AgentContext, ChatInterface, ErrorBoundary } from "@office-agents/core";
  import { onMount } from "svelte";
  import { createWordAdapter } from "../../lib/adapter";

  const adapter = createWordAdapter();
  const ctx = new AgentContext({
    namespace: adapter.storageNamespace,
    staticFiles: adapter.staticFiles,
    customCommands: adapter.customCommands,
  });

  onMount(() => {
    if (!import.meta.env.DEV) return undefined;

    let stopped = false;
    let stopBridge: (() => void) | undefined;

    void import("@office-agents/bridge/client").then(
      ({ startOfficeBridge }) => {
        if (stopped) return;

        const bridge = startOfficeBridge({
          app: "word",
          adapter,
          vfs: ctx,
        });
        stopBridge = () => bridge.stop();
      },
    );

    return () => {
      stopped = true;
      stopBridge?.();
    };
  });
</script>

<ErrorBoundary>
  <div class={`flex h-screen w-full flex-col overflow-hidden ${CHATTY_GATEWAY_MODE ? "chatty-office-shell" : ""}`}>
    {#if CHATTY_GATEWAY_MODE}
      <ChattyAuthBootstrap appName="Chatty for Word" pluginName="word" />
    {/if}
    <div class="min-h-0 flex-1">
      <ChatInterface {adapter} context={ctx} />
    </div>
  </div>
</ErrorBoundary>
